export const stepsMeta = {
  default: {
    label: "Placeholder label",
    description: "Placeholder description",
    icon: "mdi-emoticon-outline",
    color: "yellow",
  },
  TRIGGER: {
    default: {
      label: "Choose a trigger",
      description: "Choose a trigger",
      icon: "mdi-lightning-bolt",
      color: "grey",
    },
    init: {
      label: "Choose a trigger",
      description: "Choose a trigger",
      icon: "mdi-lightning-bolt",
      color: "grey",
    },
    ACCOUNT_STATUS_CHANGED: {},
    ACCOUNT_TYPE_CHANGED: {
      label: "Account type changed",
      description: "Triggers when an account is assigned a new type.",
      icon: "mdi-account-edit-outline",
      color: "blue",
    },
    ADDED_TO_TEAM: {
      label: "Added to a team",
      description: "Triggers when a new member is added to a team.",
      icon: "mdi-account-multiple-plus-outline",
      color: "blue",
    },
    ALLOWANCE_CONSUMED: {
      label: "Allowance was consumed",
      description:
        "Triggers when an account’s allowance amount decreases, e.g. after a booking or purchase that consumes allowance.",
      icon: "mdi-swap-vertical",
      color: "purple",
    },
    PASS_ALLOWANCE_FULLY_USED: {
      label: "Pass allowance fully used",
      description: "Triggers when a pass’s allowance reaches zero.",
      icon: "mdi-gauge-empty",
      color: "purple",
    },
    BOOKING_CANCELED: {
      label: "Resource booking canceled",
      description: "Triggers when a booking is canceled.",
      icon: "mdi-shape-outline",
      color: "green",
      object: "booking",
    },
    BOOKING_ENDED: {
      label: "Resource booking ended",
      description: "Triggers when a booking ends.",
      icon: "mdi-shape-outline",
      color: "green",
    },
    CHECKIN_CANCELED: {},
    DATE: {
      label: "Date",
      description:
        "Triggers before, after, or on a date related to an account.",
      icon: "mdi-calendar-blank",
      color: "orange",
    },
    DOCUMENT_COMPLETE: {
      label: "Document complete",
      description:
        "Triggers when all required parties have signed a document and it is marked as signed.",
      icon: "mdi-file-document-edit-outline",
      color: "grey",
    },
    DOCUMENT_SENT: {
      label: "Document sent",
      description: "Triggers when a document is sent to a user for signing.",
      icon: "mdi-file-document-outline",
      color: "grey",
    },
    INVOICE_PAID: {
      label: "Invoice paid",
      description:
        "Triggers when an invoice receives a payment and the balance becomes zero.",
      color: "grey",
      icon: "mdi-invoice-text-check-outline",
    },
    INVOICE_DUE: {
      label: "Invoice became due",
      description: "Triggers when an invoice changes to due.",
      color: "grey",
      icon: "mdi-invoice-clock-outline",
    },
    INVOICE_OVERDUE: {
      label: "Invoice became overdue",
      description:
        "Triggers when an invoice changes to overdue (controlled by your Invoice Policy in settings).",
      color: "grey",
      icon: "mdi-invoice-clock-outline",
    },
    INVOICE_PAYMENT_FAILED: {},
    INVOICE_STATUS_CHANGED: {},
    MANUAL: {
      label: "Manual enrollment",
      description:
        "Can be manually triggered by an admin from Inbox or Account menu.",
      icon: "mdi-hand-back-left-outline",
      color: "pink",
    },
    NEW_UNCONFIRMED_USER: {
      label: "New unconfirmed user",
      description:
        "Triggers after a user is added but has not completed creating their account. E.g. unfinished app onboarding, added by Inquiry form, etc.",
      icon: "mdi-account-plus-outline",
      color: "blue",
    },
    NEW_ACTIVE_USER: {
      label: "New active user",
      description: "Triggers when a user's status becomes active.",
      icon: "mdi-account-plus-outline",
      color: "blue",
    },
    ASSIGNMENT_ENDED: {
      label: "Assignment ended",
      description: "Triggers when an assignment ends.",
      icon: "mdi-calendar-text-outline",
      color: "green",
    },
    NEW_ASSIGNMENT: {
      label: "New assignment",
      description: "Triggers when an admin sets up an assignment for a user.",
      icon: "mdi-calendar-text-outline",
      color: "green",
    },
    NEW_BOOKING: {
      label: "New resource booking",
      description:
        "Triggers when a booking is created by either a user or an admin.",
      icon: "mdi-shape-outline",
      color: "green",
      object: "booking",
    },
    NEW_CHECKIN: {
      label: "New check-in",
      description: "Triggers when a user is checked in to a location.",
      icon: "mdi-check-circle-outline",
      color: "brown",
    },
    NEW_ISSUE: {
      label: "New issue raised",
      description:
        "Triggers when a user reports an issue on their app. E.g. ‘Wi-Fi is too slow’.",
      icon: "mdi-flag-outline",
      color: "red",
    },
    NEW_LEAD: {},
    NEW_PASS_SALE: {
      label: "New pass sale",
      description: "Triggers when a pass is added to a user or team’s account.",
      icon: "mdi-wallet-outline",
      color: "purple",
      object: "pass",
    },
    NEW_PLAN: {
      label: "New plan added",
      description: "Triggers when a plan is added to a user or team's account.",
      icon: "mdi-repeat",
      color: "purple",
      object: "plan",
    },
    PLAN_ENDED: {
      label: "Plan ended",
      description: "Triggers when a plan ends.",
      icon: "mdi-repeat",
      color: "purple",
      object: "plan",
    },
    NEW_PRODUCT_SALE: {
      label: "New product sale",
      description:
        "Triggers when a user buys a product or an admin adds a sale to an invoice.",
      icon: "mdi-storefront-outline",
      color: "yellow",
    },
    NEW_TOUR: {
      label: "New tour booking",
      description:
        "Triggers when a booking is created via the tour booking form.",
      icon: "mdi-calendar-blank-outline",
      color: "green",
    },
    INQUIRY_FORM_SUBMITTED: {
      label: "Inquiry form submitted",
      description:
        "Triggers when a new inquiry is submitted via the inquiry form.",
      icon: "mdi-account-question-outline",
      color: "blue",
    },
    PLAN_STATUS_CHANGED: {},
    REFERRAL_REVENUE_GENERATED: {
      label: "Referral revenue generated",
      description:
        "Triggers when an invoice is paid by an account that was referred by another account.",
      icon: "mdi-currency-usd",
      color: "grey",
    },
    REFERRED_USER_PAID_FIRST_INVOICE: {
      label: "Referred user pays first invoice",
      description:
        "Triggers the first time a referred user pays an invoice. The account that referred them is enrolled so you can send a reward. Later payments from the same referred user won't trigger it again.",
      icon: "mdi-currency-usd",
      color: "grey",
    },
    SCHEDULE: {},
    TOUR_CANCELED: {},
  },
  CONDITION: {
    default: {
      icon: "mdi-filter-variant",
      label: "Condition",
      description: "Only proceed when specific criteria is met",
      color: "yellow",
    },
  },
  DELAY: {
    default: {
      label: "Delay",
      description: "Pause actions for a certain amount of time",
      icon: "mdi-timelapse",
      color: "brown",
    },
  },
  STOP: {
    default: {
      label: "Stop",
      description:
        "Only available inside a branch. Ends the enrollment at this step",
      icon: "mdi-close-circle-outline",
      color: "red",
    },
  },
  BRANCHING: {
    default: {
      label: "Branch",
      description:
        "Create different paths to follow based on conditions. The first branch that matches will run (left to right)",
      icon_image: require("@/assets/workflows/steps/branching.svg"),
      color: "purple",
    },
  },
  ACTION: {
    default: {},
    init: {
      label: "Choose an action",
      icon: "mdi-play-speed",
      color: "grey",
    },
    ADD_ALLOWANCE: {
      label: "Add allowance",
      description: "Add allowance to a user or team",
      icon: "mdi-wallet-plus-outline",
      color: "orange",
    },
    ADD_TO_GROUP_CONVERSATION: {
      label: "Add to group conversation",
      description: "Add user to group conversation",
      icon: "mdi-account-multiple-plus-outline",
      color: "green",
    },
    ADD_INVOICE_ITEM: {
      label: "Add invoice item",
      description: "Add a charge or credit to a user or team's next invoice",
      icon: "mdi-invoice-clock-outline",
      color: "grey",
    },
    CHANGE_ACCOUNT_TYPE: {
      label: "Change account type",
      description:
        "Useful when the account type is used for conditions, e.g. resource availability",
      icon: "mdi-account-circle-outline",
      color: "pink",
    },
    CHANGE_PRIMARY_LOCATION: {
      label: "Change primary location",
      description: "Set a user’s primary location",
      icon: "mdi-map-marker-outline",
      color: "pink",
    },
    CHANGE_USER_STATUS: {
      label: "Change user status",
      description: "Set a user’s status to active or inactive",
      icon_image: require("@/assets/workflows/steps/account-check.svg"),
      color: "pink",
    },
    CREATE_TASK: {
      label: "Create a task",
      description:
        "Create a task for any admin, containing a link to the trigger of the Automation",
      icon: "mdi-checkbox-multiple-outline",
      color: "blue",
    },
    SEND_EMAIL: {
      label: "Send an email",
      description: "Send an email to a user, team, or an admin",
      icon: "mdi-email-outline",
      color: "green",
    },
    SEND_MESSAGE: {
      label: "Send a message",
      description: "Send a message to a user, team, or an admin",
      icon: "mdi-message-outline",
      color: "green",
    },
    SEND_DOC_TO_SIGN: {
      label: "Send a document for signing",
      description:
        "Have documents digitally signed and stored in the Account panel",
      icon: "mdi-signature-freehand",
      color: "green",
    },
    POST_TO_FEED: {
      label: "Post to feed",
      description: "Create a new post on the community feed",
      icon_image: require("@/assets/workflows/steps/campaign.svg"),
      color: "purple",
    },
    UPDATE_CUSTOM_PROPERTY: {
      label: "Update custom property",
      description: "Change the value of a user’s custom property",
      icon_image: "mdi-pencil-outline",
      color: "pink",
    },
  },
};
